import { useMutation } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedMutationOptions } from 'queries/types';
import { throwResponseError } from 'queries/utils';
import isOkResponse from 'utils/is-ok-response';

export function useUserLogout(
    options?: UseExposedMutationOptions<
        Api.V3.UserAction.UserLogout.Response,
        Error,
        Api.V3.UserAction.UserLogout.Payload
    >
) {
    const notify = useNotify();

    return useMutation<Api.V3.UserAction.UserLogout.Response, Error, Api.V3.UserAction.UserLogout.Payload>({
        ...options,
        mutationKey: Api.V3.UserAction.UserLogout.MutationKey(),
        mutationFn: async () => {
            const response = await new RequestAgent()
                .csrf(Api.V3.UserAction.UserLogout.Csrf())
                .post(Api.V3.UserAction.UserLogout.Endpoint(), {});

            if (isOkResponse(response)) {
                return;
            } else {
                throwResponseError(response);
            }
        },
        onError: (error, ...rest) => {
            notify.openNotification({ level: 'error', message: error.message });
            options?.onError?.(error, ...rest);
        }
    });
}
